import React, { PureComponent } from 'react';
import ReactTable from 'react-table';

import styled from 'styled-components';
import 'react-table/react-table.css';
import { epochToDate, epochToTime } from 'utils';
import { Row, Button } from '@cuemath/comps';
import PropTypes from 'prop-types';
import MODAL from 'constants/modal';
import COLORS from 'constants/colors';
import { openModal } from 'actions/modal';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ACTIONS_LABEL } from 'constants/demo-incentive';

const TableWrapper = styled.div`
  margin: 5px;
  width: 100%;
  height: 240px;
  overflow-y: scroll;
`;

const ActionWrapper = styled(Button)`
  cursor: pointer;
  background: ${({ btnColor }) => btnColor};
  border-radius: 5px;
  width: 95%;
  margin: 0px 10px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  height: 100%;
  padding: 3px 0px;
  :hover {
    background: ${({ btnColor }) => btnColor};
  }
`;

const DateFormat = 'DD-MM-YYYY';
const ADD = 'ADD';
const REMOVE = 'REMOVE';

class IncentiveTable extends PureComponent {
  demoIncentives = ({ demoIncentiveId, heading }) => {
    const { actions, createDemoBtn, filledData } = this.props;

    actions.openModal(
      'demoIncentives',
      {
        size: 'custom',
        width: '600px',
        height: MODAL.UPDATE_HEIGHT,
      },
      {
        demoIncentiveId,
        heading: heading,
        filledData,
        createDemoBtn,
      },
    );
  };

  btnBackgroundColor = (eventType, incentiveState, adminAction) => {
    if (adminAction) {
      if (adminAction.includes(ADD)) return COLORS.DARK_GREEN;

      if (adminAction.includes(REMOVE)) return COLORS.DARK_PINK;
    }
    return 'transparent';
  };

  render() {
    const { data, createDemoBtn } = this.props;

    let columnsData = [
      {
        Header: 'Demo Date and Time',
        accessor: 'demo_on',
        width: 150,
        Cell: row => {
          const { demo_on: demoOn = null } = row.original || {};
          if (!demoOn) return null;
          return (
            <Row justifyContent="center" alignItems="center">{`${epochToDate(
              demoOn,
              DateFormat,
            )} ${epochToTime(demoOn)}`}</Row>
          );
        },
      },
      {
        Header: 'Product Type',
        accessor: 'product_type',
      },
      {
        Header: 'Amount',
        accessor: 'amount',
        width: 100,
      },
      {
        Header: 'Rewarded On',
        accessor: 'rewarded_on',
        width: 150,
        Cell: row => {
          const { rewarded_on: rewardedOn = null } = row.original || {};

          if (!rewardedOn) return null;

          return (
            <Row justifyContent="center" alignItems="center">{`${epochToDate(
              rewardedOn,
              DateFormat,
            )} ${epochToTime(rewardedOn)}`}</Row>
          );
        },
      },
      {
        Header: 'Settled On',
        accessor: 'settled_on',
        width: 150,
        Cell: row => {
          const { settled_on: settledOn = null } = row.original || {};

          if (!settledOn) return null;

          return (
            <Row justifyContent="center" alignItems="center">{`${epochToDate(
              settledOn,
              DateFormat,
            )}`}</Row>
          );
        },
      },
      {
        Header: 'Demo State',
        accessor: 'demo_state',
        width: 120,
      },
      {
        Header: 'Incentive Type',
        accessor: 'incentive_type',
        width: 120,
      },
      {
        Header: 'Incentive State',
        accessor: 'incentive_state',
        width: 120,
      },
    ];

    columnsData.push({
      Header: 'Action',
      accessor: 'name',
      Cell: ({ original }) => {
        const {
          event_type: eventType,
          incentive_state: incentiveState,
          id: demoIncentiveId,
          admin_action: adminAction,
        } = original || {};

        if (createDemoBtn) {
          return (
            <Row justifyContent="center" alignItems="center">
              <ActionWrapper
                color={COLORS.WHITE}
                onClick={() =>
                  this.demoIncentives({
                    demoIncentiveId: null,
                    heading: ACTIONS_LABEL['CREATE_DEMO_INCENTIVE'],
                  })
                }
                label={ACTIONS_LABEL['CREATE_DEMO_INCENTIVE']}
              />
            </Row>
          );
        }
        if (!adminAction) return null;

        return (
          <Row justifyContent="center" alignItems="center">
            <ActionWrapper
              color={COLORS.WHITE}
              btnColor={() =>
                this.btnBackgroundColor(eventType, incentiveState, adminAction)
              }
              onClick={() =>
                this.demoIncentives({
                  demoIncentiveId,
                  heading: ACTIONS_LABEL[adminAction],
                })
              }
              label={ACTIONS_LABEL[adminAction]}
            />
          </Row>
        );
      },
    });

    const tableColumns = [
      {
        Header: ``,
        columns: columnsData,
      },
    ];

    return (
      <TableWrapper>
        <ReactTable
          data={data}
          columns={tableColumns}
          showPagination={true}
          defaultPageSize={data.length || 4}
          pageSizeOptions={[4, 30, 50, 100, 200, 500]}
          style={{
            height: '240px',
            textAlign: 'center',
          }}
          className="-striped -highlight"
        />
      </TableWrapper>
    );
  }
}

IncentiveTable.propTypes = {
  actions: PropTypes.shape({
    openModal: PropTypes.func.isRequired,
  }).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({}).isRequired).isRequired,
  filledData: PropTypes.shape({}).isRequired,
};

export default connect(null, dispatch => ({
  actions: bindActionCreators({ openModal }, dispatch),
}))(IncentiveTable);
